module.exports = __webpack_public_path__ + "img/m-vkus.9d31ac4b.svg";